import { router } from "@inertiajs/react";
import { SignatureForm } from "../../components/signature/SignatureForm";
import { getFullName } from "../../helpers/stringHelper";
import { useYearContext } from "../../hooks/useYearContext";
import { ContentShell } from "../../layout/ContentShell";
import type { Coach } from "../../models/coach";
import type { Signature } from "../../models/signature";
import { signature_path, signatures_path } from "../../routes";

type SignatureEditProps = {
  coaches: Coach[];
  signature: Signature;
};

export default function SignatureEdit({ coaches, signature }: SignatureEditProps) {
  const { pathWithYearContext } = useYearContext();
  return (
    <ContentShell onBack={() => router.get(pathWithYearContext(signatures_path))} title={`Unterschrift von ${getFullName(signature)}`}>
      <SignatureForm
        coaches={coaches}
        signature={signature}
        onSubmit={(values) => router.patch(pathWithYearContext(signature_path, signature.id), values)}
        saveButtonLabel="Speichern"
      />
    </ContentShell>
  );
}
